import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/messaging'
import 'firebase/storage'

const config = {
  apiKey: 'AIzaSyCORh6I9aaxy240mFJHks0O0Uq7FoWdq9s',
  authDomain: 'upio-user-app-1579104974406.firebaseapp.com',
  databaseURL: 'https://upio-user-app-1579104974406.firebaseio.com',
  projectId: 'upio-user-app-1579104974406',
  storageBucket: 'upio-user-app-1579104974406.appspot.com',
  messagingSenderId: '142836255007',
  appId: '1:142836255007:web:f355baa6fefe2ad1fe482a',
  measurementId: 'G-5TRWKYSXLX',
}

firebase.initializeApp(config)

// Initialize Cloud Firestore through Firebase
const db = firebase.firestore()

// Disable deprecated features
db.settings({
})

db.enablePersistence({ synchronizeTabs: true })

const storage = firebase.storage()

const messaging = firebase.messaging()

export default {
  db,
  storage,
  messaging,
}
